import { render } from "./DbsMyBookingBottomButtons.vue?vue&type=template&id=2cded7d5&scoped=true"
import script from "./DbsMyBookingBottomButtons.vue?vue&type=script&lang=js"
export * from "./DbsMyBookingBottomButtons.vue?vue&type=script&lang=js"

import "./DbsMyBookingBottomButtons.vue?vue&type=style&index=0&id=2cded7d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cded7d5"

export default script